@use '../../style/utils';

$_CLASS: '.joy-product-tour';

:host {
    /**
     * @prop --product-tour-width - product tour max width
     * @prop --product-tour-width - product tour max width
     */
    --product-tour-arrow-size: 16px;
    --product-tour-z-index: var(--joy-core-z-index-product-tour);
    --product-tour-spotlight-padding: var(--joy-core-spacing-2);

    display: none;
    position: absolute;
    left: 0;
    top: 0;
    z-index: var(--product-tour-z-index);
    width: var(--product-tour-width);
    max-width: 100%;
}

#{$_CLASS} {
    position: relative;
    max-width: var(--product-tour-width);
    background-color: white;
    border-radius: var(--joy-core-radius-3);
    box-shadow: var(--joy-core-elevation-4);
    padding: var(--joy-core-spacing-6);
    color: var(--joy-color-neutral-60);

    &__hasPreheader {
        margin-bottom: var(--joy-core-spacing-4);
    }

    &__preheader {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        joy-icon {
            position: absolute;
            right: 15px;
            top: 15px;
            outline: none;
            cursor: pointer;
            padding: 10px;
            background: white;

            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0.05;
                background-color: transparent;
                border-radius: 50%;
                transition: background-color var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            }

            &:hover, &:focus {
                &:after {
                    background-color: currentColor;
                }
            }
        }
    }

    &__header {
        padding-right: 50px;
        margin-bottom: var(--joy-core-spacing-2);
        @include utils.getFontProperties(primary-650);
    }

    &__content {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        @include utils.getFontProperties(primary-300);

        &___icon {
            margin-right: var(--joy-core-spacing-4);
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: var(--joy-core-spacing-4);

        &___steps {
            color: var(--joy-color-neutral-50);
            @include utils.getFontProperties(primary-600);
        }

        &___cta {
            display: flex;
            align-items: center;
            justify-content: space-between;

            ::slotted(*) {
                margin-left: var(--joy-core-spacing-8);
            }
        }
    }


    &__arrow {
        position: absolute;
        background: white;
        width: 26px;
        height: 26px;
        z-index: 1;
        transform: rotate(45deg);
    }
}